import type { PlanCard, PlansListInitData } from './types';

function normalizeBaseUrl(value: string): string {
    return value.replace(/\/+$/, '');
}

function buildRestUrl(baseUrl: string, path: string): string {
    return new URL(normalizeBaseUrl(baseUrl) + path, window.location.origin).toString();
}

/**
 * Récupère les plans achetables publics pour la locale courante.
 * Endpoint public GET /gas/v1/membership/plans/public — enveloppe { data: { plans } }.
 */
export async function fetchPublicPlans(init: PlansListInitData): Promise<PlanCard[]> {
    const url = buildRestUrl(
        String(init.rest_base_url || '/wp-json/gas/v1'),
        `/membership/plans/public?locale=${encodeURIComponent(init.locale)}`,
    );

    const headers: Record<string, string> = { Accept: 'application/json' };
    if (init.rest_nonce) {
        headers['X-WP-Nonce'] = init.rest_nonce;
    }

    const response = await fetch(url, { credentials: 'same-origin', headers });
    if (!response.ok) {
        throw new Error(`REST request failed (${response.status}).`);
    }

    const parsed = (await response.json()) as { data?: { plans?: PlanCard[] } };
    return parsed.data?.plans ?? [];
}
